import {
  INDIVIDUAL_SEPARATOR_IDENTIFIER,
  PAGE_SEPARATOR_IDENTIFIER
} from '@components/UI-Components/HierarchyWiseItems/constants'
import { PaginatedHierarchyItemsDataStore } from '@stores/paginated-hierarchy-items/PaginatedHierarchyItemsDataStore'
import { PaginatedHierarchyItemsUIStore } from '@stores/paginated-hierarchy-items/PaginatedHierarchyItemsUIStore'
import { action } from 'mobx'
import ActiveCellItemStore from './ActiveCellItemStore'
import PaginatedTableHierarchyScrollPositionStore from './PaginatedTableHierarchyScrollPositionStore'
import { TableElementRefStore } from './TableElementRefStore'

export default abstract class PaginatedTableHierarchyItemsUIStore<
  T extends PaginatedHierarchyItemsDataStore
> extends PaginatedHierarchyItemsUIStore<T> {
  elementRefStore = new TableElementRefStore()
  scrollPositionStore = new PaginatedTableHierarchyScrollPositionStore(
    this.elementRefStore
  )
  activeItemStore = new ActiveCellItemStore()

  fetchData(id: string, fromIndex?: number, toIndex?: number) {
    if (id === this.hierarchyRootId) {
      return
    }
    const hierarchy = id.includes(PAGE_SEPARATOR_IDENTIFIER)
      ? id.split(PAGE_SEPARATOR_IDENTIFIER)[0]
      : id.split(INDIVIDUAL_SEPARATOR_IDENTIFIER)[0]

    // fetch data only for leaf node
    if (!this.hierarchyDetails[hierarchy]?.isLeaf) {
      return
    }
    return super.fetchData(id, fromIndex, toIndex)
  }

  @action
  navigateToCell(rowIndex?: number, colIndex?: number) {
    this.activeItemStore.setRowAndColIndex(rowIndex, colIndex)
    this.setActiveItemIndexAndScroll(rowIndex)
    this.scrollPositionStore.scrollToColIndex(colIndex)
  }
}
